import React, { FC, useMemo, useState } from "react";
import { Map } from "../../../../models/Models";
import { PlanbyChannel, PlanbyEvent, PlanbyEventCollection, DateTimeRange } from "../../../../models/epg/Models";
import SingleDayEpg from "./SingleDayEpg";
import dayjs from "dayjs";
import { isEqual } from "lodash-es";

interface Props {
    dates?: string[];
    channels?: PlanbyChannel[];
    eventsByDateByChannel?: Map<PlanbyEventCollection[]>;
}

const MultiDayEpg: FC<Props> = ({
    dates = [],
    channels = [],
    eventsByDateByChannel = {},
}) => {

    const [ componentDates, setComponentDates ] = useState(dates);

    const [ selectedDate, setSelectedDate ] = useState(dayjs().format("YYYY-MM-DD"));

    if (!isEqual(dates, componentDates)) {
        setComponentDates(dates);
        const todayDate = dayjs().format("YYYY-MM-DD");
        setSelectedDate(
            !dates || dates.includes(todayDate)
                ? todayDate
                : dates[0]
        );
    }

    const {
        eventsByDate,
        dateTimeRangeByDate,
    } = useMemo(() => {
            const eventsByDate: Map<PlanbyEvent[]> = {};
            const dateTimeRangeByDate: Map<DateTimeRange> = {};

            dates.map((date: string) => {
                let eventsForDate: PlanbyEvent[] = [];
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                Object.entries(eventsByDateByChannel).forEach(([ channelTag, eventsByDateForChannel ]) => {
                    const eventsForDateForChannel = eventsByDateForChannel?.find((eventCollection) => date == eventCollection.day);
                    if (!eventsForDateForChannel) return;

                    eventsForDate = eventsForDate.concat(eventsForDateForChannel.events);

                    if (!dateTimeRangeByDate[date]) {
                        dateTimeRangeByDate[date] = {
                            startDateTime: eventsForDateForChannel.startDateTime,
                            endDateTime: eventsForDateForChannel.endDateTime,
                        };
                    }

                    if (dayjs(eventsForDateForChannel.startDateTime).isAfter(dateTimeRangeByDate[date].startDateTime)) {
                        dateTimeRangeByDate[date].startDateTime = eventsForDateForChannel.startDateTime;
                    }

                    if (dayjs(eventsForDateForChannel.endDateTime).isBefore(dateTimeRangeByDate[date].endDateTime)) {
                        dateTimeRangeByDate[date].endDateTime = eventsForDateForChannel.endDateTime;
                    }

                });
                eventsByDate[date] = eventsForDate;
            });

            return {
                eventsByDate,
                dateTimeRangeByDate,
            };
        }, [ dates, eventsByDateByChannel ]);

    const isDateSelected = (selectedDate: string, date: string) => {
        return selectedDate == date;
    };

    return (
        <>
            <ul
                className="flex flex-row flex-nowrap gap-2 my-2 text-center px-1"
            >
                { dates.map((date) =>
                    <li
                        key={date}
                        className={
                            `inline-block flex-1 flex justify-center h-14 rounded-lg bg-gradient-to-r ` +
                            `${isDateSelected(selectedDate, date) ? "from-gray-700 to-gray-500 dark:from-blue-900 dark:to-blue-700" : "bg-neutral-950 hover:from-neutral-900 hover:to-neutral-800"}`
                        }
                    >
                        <a
                            onClick={() => setSelectedDate(date)}
                            className="block w-14 h-14 cursor-pointer"
                        >
                            <span className="block w-full text-base font-black">{dayjs(date).format("DD")}</span>
                            <span className="block w-full text-xs font-bold">{dayjs(date).format("MMM").toUpperCase()}</span>
                            <span className="block w-full text-xs font-light">{dayjs(date).format("YYYY")}</span>
                        </a>
                    </li>
                )}
            </ul>
            <div
                className="min-h-0 min-w-0 flex-grow flex-shrink"
            >
                {
                    selectedDate && eventsByDate && eventsByDate[selectedDate] && dateTimeRangeByDate && dateTimeRangeByDate[selectedDate] &&
                    (<SingleDayEpg
                        date={selectedDate}
                        startDateTime={dayjs(dateTimeRangeByDate[selectedDate].startDateTime).toISOString()}
                        endDateTime={dayjs(dateTimeRangeByDate[selectedDate].endDateTime).toISOString()}
                        channels={channels}
                        events={eventsByDate[selectedDate]}
                     />)
                }
            </div>
        </>
    );
};

export default MultiDayEpg;